module.exports = __webpack_public_path__ + "media/welcome-message/webinar@3x-08a7394b.png";